// extracted by mini-css-extract-plugin
export default {"DividerVertical":"DividerVertical_DividerVertical__k5P1c"};